// extracted by mini-css-extract-plugin
export default {"Emojify":"bbl_a bhk_g"};